/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
  Link,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import "./style.css";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import { useNavigate } from "react-router-dom";
import { useVehicleNumberEdit } from "./hooks/useVehicleNumberEdit";
import VehicleNumberEditDialog from "./components/VehicleNumberEditDialog";
//import AllottedStatusFilter from "./components/AllottedStatusFilter";
import VehicleRow from "./components/VehicleRow";
import AllottedStatusFilter from "./components/AllottedStatusFilter";
import { downloadReport } from "../../utils/downloadReport";

const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState<any>();
  const [evDetailListData, setEvDetailListData] = useState<any[]>([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [editData, setEditData] = useState<any>(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [editForm, setEditForm] = useState({
    imei: "",
    bleMac: "",
    msisdn: "",
    iotType: "",
  });
 const [allottedStatusFilter, setAllottedStatusFilter] = useState("");
  const [downloading, setDownloading] = useState(false);
 
  
  const navigate = useNavigate();
  
  const {
    editingVehicle,
    isUpdating,
    startEdit,
    cancelEdit,
    updateVehicleNumber,
    setNewVehicleNo,
  } = useVehicleNumberEdit(
    () => {
      setSnackbarMessage("Vehicle number updated successfully");
      setSnackbarSeverity("success");
      setShowErrorSnackbar(true);
      evDeatailList();
    },
    (errorMessage: string) => {
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setShowErrorSnackbar(true);
    }
  );

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };

  const rowsPerPage = 10;
  const pageRange = 10;
  const pageCount = Math.ceil(totalCount / rowsPerPage);
  
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const handleCreateev = () => {
    navigate("/createEv");
  };

  const handleDownloadReport = () => {
    downloadReport(
      () => ZyppLiteApi.api.downloadVehicleDetailReport(),
      "Vehicle_Details_Report.xlsx",
      (msg) => { setSnackbarMessage(msg); setSnackbarSeverity("success"); setShowErrorSnackbar(true); },
      (msg) => { setSnackbarMessage(msg); setSnackbarSeverity("error"); setShowErrorSnackbar(true); },
      setDownloading
    );
  };

  const evDeatailList = () => {
    ZyppLiteApi.api
      ?.evDeatailList(searchValInput, page, rowsPerPage, allottedStatusFilter || undefined)
      .then((response) => {
        if (response.data.vehicleDetailsV2.length > 0) {
          setEvDetailListData(response.data.vehicleDetailsV2);
          setTotalCount(response.data.total);
        } else {
          setEvDetailListData([]);
          setTotalCount(1);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };

  useEffect(() => {
    evDeatailList();
  }, [page, rowsPerPage, searchValInput, allottedStatusFilter]);

  useEffect(() => {
    // Reset to first page when search or filter changes
    setPage(0);
  }, [searchValInput, allottedStatusFilter]);

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };
  const handleAdd = (item: any) => {
    navigate("/ridertrack", {
      state: {
        latitude: item.latitude,
        longitude: item.longitude,
        vehicleNo: item.vehicleNo, // include this!
        lockLastTimeLocationUpdated: item.lockLastTimeLocationUpdated, // include this!
      },
    });
  };

  const downloadRC = (item: any) => {
    ZyppLiteApi.api
      ?.downloadDocumentRc(item.vehicleId)
      .then((response) => {
        if (response?.code === 2000 && response?.data?.downloadLink) {
          window.open(response.data.downloadLink, "_blank");
          setSnackbarSeverity("success");
        } else if (response?.code === 400) {
          setSnackbarMessage("RC Document Not Found");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("error");
        } else {
          setSnackbarSeverity("error");
          setSnackbarMessage(
            response?.message || "Error downloading RC document"
          );
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Download RC error: ", error);
        setSnackbarMessage("Failed to download RC document");
        setShowErrorSnackbar(true);
        setSnackbarSeverity("error");
      });
  };

  const downloadInsurance = (item: any) => {
    ZyppLiteApi.api
      ?.downloadDocumentInsurance(item.vehicleId)
      .then((response) => {
        if (response?.code === 2000 && response?.data?.downloadLink) {
          window.open(response.data.downloadLink, "_blank");
          setSnackbarSeverity("success");
        } else if (response?.code === 400) {
          setSnackbarMessage("Insurance Document Not Found");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("error");
        } else {
          setSnackbarSeverity("error");
          setSnackbarMessage(
            response?.message || "Error downloading insurance document"
          );
          setSnackbarSeverity("error");
          setShowErrorSnackbar(true);
        }
      })
      .catch((error) => {
        console.error("Download Insurance error: ", error);
        setSnackbarMessage("Failed to download Insurance document");
        setShowErrorSnackbar(true);
        setSnackbarSeverity("error");
      });
  };
  const handleUpdateIoTDetails = () => {
    if (!editData) return;

    const payload = {
      bleMac: editForm.bleMac,
      msisdn: editForm.msisdn,
      iotType: Number(editForm.iotType),
      vehicleId: editData.vehicleId,
      newImei: editForm.imei,
    };

    ZyppLiteApi.api
      ?.updateVehicleIoT(payload)
      .then((response: any) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Vehicle IoT details updated successfully");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("success");
          evDeatailList();
          setEditData(null);
        } else {
          setSnackbarMessage(response?.message || "Update failed");
          setShowErrorSnackbar(true);
          setSnackbarSeverity("error");
        }
      })
      .catch((error: any) => {
        console.error("Error during approval:", error);

        const message =
          error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred";

        setSnackbarMessage(message);
        setSnackbarSeverity("error");
        setShowErrorSnackbar(true);
      });
  };

  return (
    <div className="p-10">
      <div className="w-full flex bg-white min-h-80 box-shadow rounded-xl p-4">
        <div className="w-full">
          <Grid container spacing={5} className="w-full flex justify-between ">
            <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  EV Details
                </h2>
              </div>
            </Grid>
            <Grid item md={9}>
              <div className="flex mr-4 gap-3">
                <div className="flex w-full justify-end gap-3">
                  <div style={{ minWidth: "200px" }}>
                    <AllottedStatusFilter
                      value={allottedStatusFilter}
                      onChange={setAllottedStatusFilter}
                    />
                  </div>
                  <div>
                    <TextField
                      placeholder="Search  Vehicle Number"
                      id="outlined-basic"
                      variant="outlined"
                      onChange={(search: any) =>
                        setSearchValInput(search.target.value)
                      }
                      value={searchValInput}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={handleClearSearch}
                          >
                            <ClearIcon style={{ cursor: "pointer" }} />
                          </InputAdornment>
                        ),
                        style: { height: "40px", borderRadius: "25px" },
                      }}
                    />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Button
                      onClick={handleDownloadReport}
                      disabled={downloading}
                      style={{
                        backgroundColor: "#06B681",
                        padding: "5px 18px",
                        color: "#fff",
                        borderRadius: "40px",
                        textTransform: "none",
                        fontSize: "16px",
                      }}
                    >
                      <DownloadIcon sx={{ mr: 0.5 }} />
                      {downloading ? "Downloading..." : "Download"}
                    </Button>
                    <Link
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        handleCreateev();
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#000",
                          padding: "5px 18px",
                          color: "#fff",
                          borderRadius: "40px",
                          textTransform: "none",
                          fontSize: "16px",
                        }}
                      >
                        <AddIcon /> Add EV
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <TableContainer style={{ width: "100%", overflowX: "auto" }}>
            {!evDetailListData ? ( // Check if API response is still undefined (loading)
              <LinearProgress />
            ) : typeof evDetailListData === "string" ? ( // If API returns "No Data Found" as a string
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : evDetailListData.length === 0 ? ( // If the array is empty
              <Typography style={{ textAlign: "center", padding: "10px" }}>
                No data available
              </Typography>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 120 }}
                    >
                      Vehicle No
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 150 }}
                    >
                      Allotted Date
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 150 }}
                    >
                      Allotted Status
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Fleet Name
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 110 }}
                    >
                      Average Speed
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 130 }}
                    >
                      Total Distance Travelled
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 130 }}
                    >
                      Total Carbon Saved
                    </TableCell>
                     <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 180 }}
                    >
                      Last Location Date/Time 
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 180 }}
                    >
                      IMEI Number
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 100 }}
                    >
                      RC Document
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 100 }}
                    >
                      Insurance Document
                    </TableCell>
                    <TableCell
                      style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                      sx={{ minWidth: 100 }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {evDetailListData.map((item: any, index: any) => (
                    <VehicleRow
                      key={index}
                      item={item}
                      tableBodyCellStyle={tableBodyCellStyle}
                      onEditVehicleNumber={(vehicleId, vehicleNo) =>
                        startEdit(vehicleId, vehicleNo)
                      }
                      onDownloadRC={downloadRC}
                      onDownloadInsurance={downloadInsurance}
                      onTrackVehicle={handleAdd}
                      onEditIoT={(vehicleItem) => {
                        setEditData(vehicleItem);
                        setEditForm({
                          imei: vehicleItem.imei || "",
                          bleMac: vehicleItem.bleMac || "",
                          msisdn: vehicleItem.msisdn || "",
                          iotType: vehicleItem.iotType || "",
                        });
                      }}
                    />
                  ))}
                </TableBody>
              </Table>
            )}
          </TableContainer>

          <div className="pl-2 pt-4 pb-2 pr-16">
            <div
              className="pagination"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <button
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginRight: "6px",
                  }}
                >
                  {"<"}
                </button>
                {renderPageNumbers()}
                <button
                  onClick={() => handlePageChange(page + 1)}
                  disabled={page >= pageCount - 1}
                  style={{
                    fontFamily: "Rubik",
                    fontSize: "20px",
                    marginLeft: "6px",
                  }}
                >
                  {">"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Snackbar
          open={showErrorSnackbar}
          autoHideDuration={8000}
          onClose={() => setShowErrorSnackbar(false)}
        >
          <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
        </Snackbar>
        <Dialog open={!!editData} onClose={() => setEditData(null)}>
          <DialogTitle>Edit Vehicle IoT Details</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label={
                <span>
                  IMEI<span style={{ color: "red" }}> *</span>
                </span>
              }
              fullWidth
              inputProps={{
                maxLength: 15,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              value={editForm.imei}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                setEditForm({ ...editForm, imei: value });
              }}
            />
            <TextField
              margin="dense"
              label={
                <span>
                  BLE MAC<span style={{ color: "red" }}> *</span>
                </span>
              }
              fullWidth
              value={editForm.bleMac}
              onChange={(e) =>
                setEditForm({ ...editForm, bleMac: e.target.value })
              }
            />
            <TextField
              margin="dense"
              label={
                <span>
                  MSISDN<span style={{ color: "red" }}> *</span>
                </span>
              }
              fullWidth
              value={editForm.msisdn}
              onChange={(e) =>
                setEditForm({ ...editForm, msisdn: e.target.value })
              }
            />
            <TextField
              margin="dense"
              label={
                <span>
                  IoT Type<span style={{ color: "red" }}>*</span>
                </span>
              }
              fullWidth
              value={editForm.iotType}
              onChange={(e) =>
                setEditForm({ ...editForm, iotType: e.target.value })
              }
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditData(null)} sx={{ color: "red" }}>
              Cancel
            </Button>
            <Button
              onClick={handleUpdateIoTDetails}
              variant="contained"
              sx={{ backgroundColor: "#00CD5B" }}
              disabled={
                !editForm.imei ||
                editForm.imei.length !== 15 ||
                !editForm.bleMac ||
                !editForm.msisdn ||
                !editForm.iotType
              }
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <VehicleNumberEditDialog
          open={!!editingVehicle}
          currentVehicleNo={editingVehicle?.currentVehicleNo || ""}
          newVehicleNo={editingVehicle?.newVehicleNo || ""}
          isUpdating={isUpdating}
          onNewVehicleNoChange={setNewVehicleNo}
          onSave={updateVehicleNumber}
          onCancel={cancelEdit}
        />
      </div>
    </div>
  );
};

export default FleetDailyReport;
